class SetSingleCourseInCalendar {
  constructor() {
    this.option = document.querySelector('#single_class');
    this.class = document.querySelector('#forerkortklasse');
    if (this.class && this.option) {
      this.option.value = this.class.value;
    }
  }
}

export default SetSingleCourseInCalendar;